/* eslint-disable react/prop-types */
import React, { useState, useMemo, createContext } from 'react';
import NowItsUpToUsModal from '../components/molecules/NowItsUpToUsModal';

export const NotificationModalContext = createContext({});

export const NotificationModalContextProvider = ({ children }) => {
  const [openModal, setOpenModal] = useState(false);

  const value = useMemo(() => ({ openModal, setOpenModal }), [openModal]);

  return (
    <NotificationModalContext.Provider value={value}>
      {children}
      <NowItsUpToUsModal open={openModal} setOpen={setOpenModal} />
    </NotificationModalContext.Provider>
  );
};
